import React, { useContext } from 'react';

import { TicketsApi } from '../apis';
import { api } from '../api';

const TicketsApiContext = React.createContext(new TicketsApi(api));

export const TicketsApiProvider = TicketsApiContext.Provider;
export const useTicketsApi = (): TicketsApi => useContext(TicketsApiContext);
